<section class="d-flex flex-column flex-grow-1">

  <p class="text-center title mb-1" i18n>
    {{'setupCompleted' | translate}}
  </p>
  <p class="text-center" i18n>
    {{'takeToDashboard' | translate}}
  </p>
</section>
